// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ImageGallery = require("./ImageGallery.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyImageGallery_property_graphql = require("../../../__generated__/PropertyImageGallery_property_graphql.bs.js");

let getConnectionNodes = PropertyImageGallery_property_graphql.Utils.getConnectionNodes;

let convertFragment = PropertyImageGallery_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyImageGallery_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyImageGallery_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyImageGallery_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyImageGallery_property_graphql.node, convertFragment, fRef);
}

let PropertyFragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyImageGallery(props) {
  let property = RescriptRelay_Fragment.useFragment(PropertyImageGallery_property_graphql.node, convertFragment, props.property);
  let images = getConnectionNodes(property.images).map(img => img.fragmentRefs);
  return JsxRuntime.jsx(ImageGallery.make, {
    images: images
  });
}

let make = PropertyImageGallery;

exports.PropertyFragment = PropertyFragment;
exports.make = make;
/* ImageGallery Not a pure module */
